<template>
  <div>
    <CustomModal
      @close="$emit('close')"
      @ok="clickOk"
      :title="'New Housemate'"
      :okButtonText="'Create Housemate'"
    >
      <div slot="body">
        <div class="create-rental-schedule-error" v-if="errorMessage">
          <img src="../../assets/error_red.png" />
          <span>{{ errorMessage }}</span>
        </div>
        <div class="create-rental-basic-info-container">
          <div
            style="width: 100%"
            :class="!validName ? 'error' : ''"
            class="create-rental-label-input"
          >
            <label>Full Name</label>
            <input
              style="width: 100%"
              v-model="housemateFullName"
              placeholder="E.g. Jhon Doe"
            />
          </div>
          <div
            :class="!validPhone ? 'error' : ''"
            class="create-rental-label-input"
          >
            <label>Number</label>
            <input
              placeholder="+(00) 0000 - 0000"
              v-model="housematePhoneNumber"
            />
          </div>

          <div
            :class="!validEmail ? 'error' : ''"
            class="create-rental-label-input"
          >
            <label>Email</label>
            <input
              v-model="housemateEmail"
              placeholder="housemate-name@mail.com"
            />
          </div>
        </div>
      </div>
    </CustomModal>
  </div>
</template>
<script>
import CustomModal from '@/components/shared/modal/CustomModal.vue'
import { required, validPhone, ERRORS } from '@/functions/validation.js'
export default {
  data() {
    return {
      housemateFullName: '',
      housematePhoneNumber: '',
      housemateEmail: '',
      validName: true,
      validEmail: true,
      validPhone: true,
      errorMessage: ''
    }
  },
  methods: {
    validateForm() {
      this.validName = required(this.housemateFullName)
      this.validEmail = required(this.housemateEmail)
      this.validPhone = required(this.housematePhoneNumber)
    },
    validatePhoneFormat() {
      return validPhone(this.housematePhoneNumber)
    },
    clickOk() {
      this.validateForm()
      const allFilled = this.validName && this.validEmail && this.validPhone
      if (allFilled && this.validatePhoneFormat()) {
        let payload = {
          housemateFullName: this.housemateFullName,
          housematePhoneNumber: this.housematePhoneNumber,
          housemateEmail: this.housemateEmail
        }
        this.$emit('ok', payload)
      } else if (allFilled && !this.validatePhoneFormat()) {
        this.errorMessage = ERRORS.PHONE_FORMAT
      } else {
        this.errorMessage = ERRORS.REQUIRED_FIELDS
      }
    }
  },
  components: {
    CustomModal
  }
}
</script>

<style scoped>
.create-rental-basic-info-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: baseline;
}

.create-rental-label-input {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: flex-start;
  height: 64px;
  width: 220px;
  padding: 12px 0 12px 0;
}

.create-rental-label-input label {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  color: #4a4a4a;
}
.create-rental-label-input input {
  width: 212px;
  height: 40px;
  margin-top: 5px;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 0 8px 0 8px;
  font-size: 13px;
}

.create-rental-label-input.error input {
  border: 1px solid red;
}

.create-rental-schedule-error {
  display: flex;
  flex-flow: row nowrap;
  padding: 12px;
  width: 100%;
  color: red;
  background: rgba(223, 0, 15, 0.05);
  border-radius: 6px;
}

.create-rental-schedule-error span {
  margin-left: 12px;
  color: #df000f;
  font-family: Montserrat;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
}

.create-rental-label-input span {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  color: #4a4a4a;
}
</style>
